// @ts-nocheck
/* eslint-disable */
export const arrowOutlineUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8 7.219-3.3 3.3-.943-.943L8 5.333l4.243 4.243-.943.942z"/></svg>`,
    name: 'arrow-outline-up' as const
};